import { CommonModule } from '@angular/common'
import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'

import { ActivatedRoute, Router, RouterModule } from '@angular/router'

import { SharedModule } from '../../../../shared/shared.module'
import {
  incomingSubscription,
  PreviewPlanActivationResponse,
  SubscriptionsService,
  SubscriptionStatus
} from '../../../../services/subscriptions'
import { UserService } from '../../../../services/user.service'
import { Store } from '@ngrx/store'
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  filter,
  map,
  Observable,
  retry,
  switchMap,
  take,
  tap,
  timer
} from 'rxjs'
import { loadSubscription } from '../../../../store/auth/auth.actions'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { eps } from '../../../../services/url.service'
import { selectSubscription, selectUser } from '../../../../store/auth/auth.state'
import { RazorpayService } from '../../../../services/razorpay.service'
import {
  PaymentsService,
  SubscriptionInitiationResponse
} from '../../../../services/payments.service'
import { ToastrService } from 'ngx-toastr'
import { CouponService } from '../../../../services/coupon.service'

@Component({
  selector: 'app-choose-subscription',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    CapitalizePipe
  ],
  templateUrl: './choose-subscription.component.html',
  styleUrl: './choose-subscription.component.scss'
})
export class ChooseSubscriptionComponent implements OnInit {
  @ViewChild('addLicenceModal') addLicenceModal!: TemplateRef<any>
  @ViewChild('removeLicencesModal') removeLicencesModal!: TemplateRef<any>
  selectedOption: 'trial' | 'paid' | null = 'paid'
  plan: incomingSubscription | null = null
  subscription: incomingSubscription | null = null
  userId!: string

  user: any = null
  SubscriptionStatus = SubscriptionStatus
  modalService = inject(NgbModal)

  minimumLicences = 0
  fb = inject(FormBuilder)
  addForm!: FormGroup
  router = inject(Router)
  eps = eps
  totalLicences = 0
  subscription$ = new BehaviorSubject<any>(EMPTY)
  subscriptionId = ''
  removeForm!: FormGroup
  private userInputLicences$ = new BehaviorSubject<number | null>(null)
  planActivationSummary$!: Observable<PreviewPlanActivationResponse>

  private razorpayService = inject(RazorpayService)
  private paymentsService = inject(PaymentsService)
  private toastr = inject(ToastrService)

  selectedPlanId!: string
  currentSubscriptionId!: string
  businessId!: string
  isProcessingPayment = false
  // user: AuthState['user'] | null = null
  couponCode = ''
  private couponCode$ = new BehaviorSubject<string>('')
  licenceCount = 0
  showCouponInput = false
  wantsAutopay = false

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private store: Store,
    private subscriptionsService: SubscriptionsService,
    private couponService: CouponService
  ) {}

  //   plan = {
  //     planName: 'Professional',
  //     planType: 'Monthly',
  //     priceAfterDiscount: 999,
  //     minimumLicences: 5,
  //     currency: '₹'
  //   }
  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id') || ''

    const initialData$ = this.userService.getEmployeeByIdSubscription(this.userId).pipe(
      take(1),
      tap(user => {
        this.user = user
      }),
      switchMap(user =>
        this.subscriptionsService.getSubscriptions(user.businessId).pipe(
          map(res => ({
            sub: res?.[0] || null,
            busId: user.businessId
          }))
        )
      ),
      filter(data => !!data.sub),
      tap(({ sub, busId }) => {
        this.plan = sub!
        this.subscription = sub!

        this.businessId = busId
        this.subscriptionId = sub!.id
        this.currentSubscriptionId = sub!.id
        this.selectedPlanId = sub!.planId

        this.totalLicences = sub!.minimumLicences
        this.minimumLicences = sub!.minimumLicences
        this.licenceCount = sub!.minimumLicences
      }),
      take(1)
    )

    this.planActivationSummary$ = combineLatest([
      initialData$,
      this.userInputLicences$.pipe(debounceTime(1000), distinctUntilChanged()),
      this.couponCode$
    ]).pipe(
      switchMap(([{ sub, busId }, licencesCount, couponCode]) =>
        this.subscriptionsService.previewPlanActivation(
          sub!.id,
          sub!.planId,
          busId,
          licencesCount ?? sub!.minimumLicences,
          couponCode
        )
      ),
      tap(summary => {
        if (this.userInputLicences$.value === null) {
          this.userInputLicences$.next(summary.plan.requestedLicences)
        }
      })
    )
  }
  selectTrial() {
    this.selectedOption = 'trial'
  }

  selectPaid() {
    this.selectedOption = 'paid'
  }

  continueTrial() {
    // API call

    console.log('Start Trial')
  }

  proceedToPayment() {
    // Payment page

    console.log('Proceed Payment')
  }

  openAddModal() {
    this.initializeAddForm()
    this.modalService.open(this.addLicenceModal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  initializeAddForm() {
    this.addForm = this.fb.group({
      addedLicences: [1, [Validators.required, Validators.min(1), Validators.max(99999)]]
    })
  }
  openRemoveModal() {
    this.initializeRemoveForm()
    this.modalService.open(this.removeLicencesModal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }
  initializeRemoveForm() {
    // const removableLicences = this.totalLicences - this.usedLicences
    const maxRemovableLicences = Number(this.totalLicences) - this.minimumLicences
    this.removeForm = this.fb.group({
      removedLicences: [
        1,
        [Validators.required, Validators.min(1), Validators.max(maxRemovableLicences)]
      ]
    })
  }

  closeModal() {
    this.modalService.dismissAll()
  }

  addLicence() {
    if (this.addForm.invalid) {
      return
    }
    const { addedLicences } = this.addForm.value
    this.closeModal()
    // this.router.navigate([eps.planAndBilling.previewAddLicencesPath, this.subscriptionId], {
    //   queryParams: {
    //     newTotalLicences: addedLicences + this.totalLicences
    //   }
    // })
    this.totalLicences = Number(this.totalLicences)
    this.totalLicences += addedLicences
    // if (this.plan) {
    //   this.plan.minimumLicences = this.totalLicences
    // }
  }

  enforceLimit(event: any) {
    let value = Number(event.target.value)

    if (value > 99999) {
      event.target.value = 99999
      this.addForm.get('addedLicences')?.setValue(99999)
    }

    if (value < 0) {
      event.target.value = 0
      this.addForm.get('addedLicences')?.setValue(0)
    }
  }

  removeLicences() {
    if (this.removeForm.invalid) {
      return
    }

    const { removedLicences } = this.removeForm.value
    const newTotalLicences = Number(this.totalLicences) - removedLicences
    this.totalLicences = newTotalLicences
    this.closeModal()
    // if (this.plan) {
    //   this.plan.minimumLicences = this.totalLicences
    // }
    // this.minimumLicences = newTotalLicences
    // this.subscriptions
    //   .removeLicences(this.subscriptionId, newTotalLicences)
    //   .pipe(take(1))
    //   .subscribe({
    //     next: updated => {
    //       this.toastr.success(
    //         'Licence removal has been scheduled for your next billing date.',
    //         'Success'
    //       )
    //       this.plan = updated
    //       this.subscription$.next(updated)
    //       this.closeModal()
    //     },
    //     error: err => {
    //       this.toastr.error(err.error.message, err.error.error)
    //     }
    //   })
  }

  // onLicenceChange(newCount: number, minLicences: number): void {
  //   const validatedCount = Math.max(minLicences, Number(newCount) || minLicences)
  //   this.userInputLicences$.next(validatedCount)
  // }

  // onLicenceChange(delta: number, minLicences: number) {
  //   this.licenceCount = Math.max(minLicences, Number(this.licenceCount) + delta)
  //   // this.licenceCount = Math.max(minLicences, Number(delta) || minLicences)

  //   this.userInputLicences$.next(this.licenceCount)
  // }

  onLicenceChange(delta: number, minLicences: number) {
    const current = Number(this.licenceCount) || minLicences

    this.licenceCount = Math.max(minLicences, current + delta)
    // console.log('licencecount', this.licenceCount)
    this.userInputLicences$.next(this.licenceCount)
  }

  activateSubscription(): void {
    if (this.isProcessingPayment) return
    this.isProcessingPayment = true

    this.planActivationSummary$.pipe(take(1)).subscribe(summary => {
      const finalLicencesCount = summary.plan.requestedLicences
      const isYearlyPlan = summary.plan.billingFrequency?.toLowerCase() === 'yearly'
      const couponToSend = isYearlyPlan ? undefined : this.couponCode.trim() || undefined

      this.paymentsService
        .initiateSubscription(
          this.currentSubscriptionId,
          this.selectedPlanId,
          finalLicencesCount,
          this.user.businessId,
          couponToSend,
          this.wantsAutopay
        )
        .pipe(take(1))
        .subscribe({
          next: response => {
            this.showRazorpayCheckout(response, summary)
          },
          error: err => {
            this.isProcessingPayment = false
            this.toastr.error(err.error?.message || 'Failed to initiate payment. Please try again.')
          }
        })
    })
  }

  private showRazorpayCheckout(
    initiationResponse: SubscriptionInitiationResponse,
    summary: PreviewPlanActivationResponse
  ): void {
    this.razorpayService
      .load()
      .then(() => {
        const options = {
          key: initiationResponse.key,

          // Monthly / prorated flow
          ...(initiationResponse.type === 'order' && {
            order_id: initiationResponse.orderId,
            // amount: initiationResponse.amount,
            amount: summary.billingSummary.amountToBePaid,
            currency: initiationResponse.currency
          }),

          // Yearly subscription flow
          ...(initiationResponse.type === 'subscription' && {
            subscription_id: initiationResponse.subscriptionId
          }),

          name: 'AVR HRMS',
          description: `Activating ${summary.plan.name}`,

          handler: (response: any) => {
            // console.log('Razorpay success response', response)
            if (initiationResponse.type === 'order' && response.razorpay_payment_id) {
              this.toastr.info('Setting up auto-pay, please wait...') // NEW
              // =========================
              // MONTHLY FLOW
              // =========================
              if (initiationResponse.type === 'order' && response.razorpay_payment_id) {
                if (!this.wantsAutopay) {
                  this.toastr.success('Payment successful! Subscription activated.')
                  this.isProcessingPayment = false
                  this.checkSubscriptionAndLogout()
                  // Fetch subscription -> localStorage -> refresh
                  // this.fetchAndSaveCurrentSubscription(this.businessId)

                  // setTimeout(() => {
                  //   window.location.reload()
                  // }, 500)
                  return
                }
                this.paymentsService.authenticateMandate(response.razorpay_payment_id).subscribe({
                  next: res => {
                    const mandateOptions = {
                      key: res.key,
                      subscription_id: res.subscriptionId,
                      name: 'AVR HRMS',
                      description: 'Enable Auto Debit',

                      handler: () => {
                        this.isProcessingPayment = false
                        this.toastr.success('Subscription activated successfully!')

                        // CHECK UPDATED SUBSCRIPTION STATUS
                        this.checkSubscriptionAndLogout()
                      },

                      modal: {
                        ondismiss: () => {
                          this.isProcessingPayment = false

                          this.toastr.warning('Mandate authentication was cancelled.')
                        }
                      },

                      theme: {
                        color: '#3399cc'
                      }
                    }

                    const mandateRzp = new window.Razorpay(mandateOptions)

                    mandateRzp.open()
                  },

                  error: err => {
                    console.error('Mandate authentication failed', err)

                    this.toastr.error('Failed to authenticate mandate.')

                    this.isProcessingPayment = false
                  }
                })

                return
              }

              // =========================
              // YEARLY FLOW
              // =========================

              this.toastr.success('Payment successful! Subscription activated.')

              // CHECK UPDATED SUBSCRIPTION STATUS
              this.checkSubscriptionAndLogout()
              return
            }
          },

          prefill: {
            name: `${this.user?.firstName ?? ''} ${this.user?.lastName ?? ''}`,
            email: this.user?.email ?? '',
            contact: this.user?.mobile ?? ''
          },

          notes: {
            plan: summary.plan.name,
            licences: summary.plan.requestedLicences
          },

          modal: {
            ondismiss: () => {
              this.isProcessingPayment = false

              this.toastr.info('Payment was not completed.')
            }
          },

          theme: {
            color: '#3399cc'
          }
        }

        const rzp = new window.Razorpay(options)

        rzp.open()
      })
      .catch(error => {
        console.error('Failed to load Razorpay script', error)

        this.toastr.error(
          'Could not connect to the payment gateway. Please check your connection and try again.'
        )

        this.isProcessingPayment = false
      })
  }

  private checkSubscriptionAndLogout(): void {
    // wait for backend/localStorage update
    setTimeout(() => {
      const subscription = JSON.parse(localStorage.getItem('subscription') || '{}')

      // console.log('Updated subscription status:', subscription?.subscriptionStatus)

      if (subscription?.subscriptionStatus?.toLowerCase() === 'expired') {
        // Show success toast first
        this.toastr.success('Plan activated successfully. Redirecting to login...')

        // Delay logout so toast can be visible
        setTimeout(() => {
          // this.store.dispatch(logout())

          localStorage.clear()

          this.router.navigate(['/login'])
        }, 2500) // 2.5 seconds delay

        return
      }

      this.toastr.warning('Subscription status not updated yet.')

      this.router.navigate([eps.planAndBilling.planPath])
    }, 3000)
  }

  applyCoupon() {
    this.couponCode$.next(this.couponCode.trim())
  }

  // onLicenceInput(value: number, minLicences: number) {
  //   const validatedCount = Math.max(minLicences, Number(value) || minLicences)

  //   this.licenceCount = validatedCount
  //   this.userInputLicences$.next(this.licenceCount)
  // }

  onLicenceInput(event: Event, minLicences: number): void {
    const input = event.target as HTMLInputElement

    if (!input) return

    const value = Number(input.value)
    const validatedCount = Math.max(minLicences, value || minLicences)

    this.licenceCount = validatedCount
    input.value = String(validatedCount)

    this.userInputLicences$.next(validatedCount)
  }

  toggleCouponInput() {
    this.showCouponInput = !this.showCouponInput

    // Cancel hone par input clear ho jaye
    if (!this.showCouponInput) {
      this.couponCode = ''
    }
  }

  // private fetchAndSaveCurrentSubscription(businessId: string): void {
  //   let attempt = 0
  //   const maxAttempts = 5

  //   this.userService
  //     .getCurrentSubscription(businessId)
  //     .pipe(
  //       retry({
  //         count: maxAttempts - 1,
  //         delay: (error, retryCount) => {
  //           attempt = retryCount

  //           console.warn(
  //             `Failed to fetch current subscription. Retry ${retryCount}/${maxAttempts - 1} after 1 minute.`,
  //             error
  //           )

  //           return timer(60000)
  //         }
  //       })
  //     )
  //     .subscribe({
  //       next: subscription => {
  //         console.log('Current subscription fetched successfully:', subscription)

  //         localStorage.setItem('subscription', JSON.stringify(subscription))

  //         this.toastr.success('Subscription updated successfully.')

  //         // Reload only after successful API response
  //         setTimeout(() => {
  //           window.location.reload()
  //         }, 500)
  //       },

  //       error: err => {
  //         console.error(`Failed to fetch current subscription after ${maxAttempts} attempts.`, err)

  //         this.isProcessingPayment = false

  //         this.toastr.error(
  //           'Subscription payment was successful, but we could not update your subscription details. Please try again later.'
  //         )
  //       }
  //     })
  // }
}
